import React, { useEffect, useRef, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { JWT } from "../../constants/local-storage";
import { OmniScanOverlayManager } from "./OmniScanOverlayManager";

export default function ForgeViewer(props) {

  var urn = props.urn;
  var viewerLeft = props.viewerLeft;
  var viewerRight = props.viewerRight;
  var viewerTop = props.viewerTop;
  var viewerBottom = props.viewerBottom;
  var viewerZIndex = props.viewerZIndex;
  var loadFunction = props.loadFunction;

  // NEW
  var onViewerReady = props.onViewerReady;

  var viewerDivRef = useRef(null);
  var viewerRef = useRef(null);

  var [displaySpinner, setDisplaySpinner] = useState(true);

  useEffect(function () {

    if (!urn || urn.length < 8) {
      setDisplaySpinner(false);
      return;
    }

    setDisplaySpinner(true);

    fetch("/resolutionsoftwareplatform/forge/token", {
      method: "GET",
      headers: {
        "Authorization": localStorage.getItem(JWT)
      }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (token) {

        if (!token || !token.access_token) {
          console.error("Forge token missing access_token");
          setDisplaySpinner(false);
          return;
        }

        initAndLoad(token.access_token);

      })
      .catch(function (e) {
        console.error("Error fetching Forge token", e);
        setDisplaySpinner(false);
      });

    return function cleanup() {
      disposeViewer();
    };

  }, [urn]);

  function disposeViewer() {
    if (viewerRef.current) {
      try { viewerRef.current.tearDown(); } catch (e) {}
      try { viewerRef.current.finish(); } catch (e2) {}
      viewerRef.current = null;
    }
  }

  function initAndLoad(accessToken) {

    disposeViewer();

    if (!viewerDivRef.current) {
      setDisplaySpinner(false);
      return;
    }

    var options = {
      env: "AutodeskProduction",
      accessToken: accessToken
    };

    window.Autodesk.Viewing.Initializer(options, function () {

      var viewer = new window.Autodesk.Viewing.GuiViewer3D(viewerDivRef.current, {
        extensions: []
      });

      viewerRef.current = viewer;

      var startedCode = viewer.start();
      if (startedCode > 0) {
        console.error("Failed to start Forge Viewer.");
        setDisplaySpinner(false);
        return;
      }

      var documentId = "urn:" + urn;

      window.Autodesk.Viewing.Document.load(
        documentId,
        function onLoadSuccess(doc) {

          var defaultModel = doc.getRoot().getDefaultGeometry();

          viewer.loadDocumentNode(doc, defaultModel).then(function () {

            try { viewer.fitToView(true); } catch (e) {}

            // EXISTING HOOK
            if (loadFunction) {
              try { loadFunction(defaultModel, viewer); } catch (e2) {}
            }

            // NEW: tell parent the viewer is ready to be used
            if (onViewerReady) {
              try { onViewerReady(viewer); } catch (e3) {}
            }

            setDisplaySpinner(false);
          });

        },
        function onLoadFailure(err) {
          console.error("Forge Document load failed", err);
          setDisplaySpinner(false);
        }
      );
    });
  }

  var frame = {
    position: "absolute",
    left: viewerLeft,
    top: viewerTop,
    right: viewerRight,
    bottom: viewerBottom,
    zIndex: viewerZIndex
  };

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      {displaySpinner && (
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(0,0,0,0.25)",
          zIndex: 10
        }}>
          <CircularProgress color="inherit" />
        </div>
      )}

      <div ref={viewerDivRef} style={frame} />
	  
    </div>
  );
}
